import { Component, OnDestroy, OnInit } from '@angular/core'
import { faInfoCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { Store, Select } from '@ngxs/store'
import { Observable, Subject } from 'rxjs'
import { takeUntil, tap } from 'rxjs/operators'
import { ApiClass, ApiStatusStreamType } from 'src/app/interfaces/component'
import { StudentAdmissionsState } from 'src/app/store/state/student-admissions.state'
import { ToggleMessagesIsActive } from 'src/app/store/actions/message.actions'

@Component({
  selector: 'mu-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
})
export class MuStatusBarComponent
  extends ApiClass
  implements OnInit, OnDestroy
{
  faInfo: IconDefinition = faInfoCircle

  constructor(public store: Store) {
    super(ApiStatusStreamType.ADMISSION)
  }
  private ngUnsubscribe = new Subject()
  public regStatus: string
  public regSubStatus: string

  @Select(StudentAdmissionsState.selectedRegStatus)
  selectedRegStatus: Observable<{ regStatus: string; regSubStatus: string }>

  ngOnInit() {
    this.selectedRegStatus
      .pipe(
        takeUntil(this.ngUnsubscribe),
        tap((status) => {
          this.regStatus = status.regStatus
          this.regSubStatus = status.regSubStatus
        })
      )
      .subscribe()
  }

  subStatus() {
    if (this.regStatus === '5') {
      if (this.regSubStatus === '03') {
        return 'withdrawn'
      } else {
        return 'rejected'
      }
    }
  }

  openMessageCenter() {
    this.store.dispatch(new ToggleMessagesIsActive())
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.unsubscribe()
  }
}
